import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlcmeonContextService } from '../core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from '../shared/services/basic.service';
import { ErrorHandlingService } from '../shared/services/error-handling.service';
import { UserPreferencesAccount, UserPreferencesNotifications } from './shared/models';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService {
  constructor(
    private httpClient: HttpClient,
    private alcmeonContextService: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService
  ) {}

  updateAccount(data: UserPreferencesAccount) {
    return this.httpClient
      .post(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/preferences/account`, data)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateNotifications(data: UserPreferencesNotifications) {
    return this.httpClient
      .post(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/preferences/notifications`, data)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
